import type { CategoryRoom } from "api/categoryRooms/categoryRoomsApiSlice";

/**
 * The public plan (#3075): a category's rooms behind one dropdown, each room's
 * week below it — built to sit in an iframe on the tenant's website.
 */

/** A room's name in the visitor's language, its segment name under the hall's. */
export const planRoomLabel = (room: CategoryRoom, language: string): string => {
  const own = room.langNames?.[language]?.title?.trim() || room.name;
  const part = room.partOfRoom;
  if (!part) return own;
  const whole = part.langNames?.[language]?.title?.trim() || part.name;
  return whole ? `${whole} – ${own}` : own;
};

/** The dropdown's groups: by city, in first-seen order; rooms without a city last. */
export const planRoomGroups = (
  rooms: CategoryRoom[]
): { city: string | null; rooms: CategoryRoom[] }[] => {
  const groups = new Map<string, { city: string | null; rooms: CategoryRoom[] }>();
  for (const room of rooms) {
    const key = room.city?.trim() || "";
    if (!groups.has(key)) groups.set(key, { city: key || null, rooms: [] });
    groups.get(key)!.rooms.push(room);
  }
  const withCity = Array.from(groups.values()).filter((g) => g.city !== null);
  const without = groups.get("");
  return without ? [...withCity, without] : withCity;
};

/** The room shown: the one the link names if the category has it, else the first. */
export const planRoomShown = (
  rooms: CategoryRoom[],
  requested: string | null
): CategoryRoom | null =>
  rooms.find((room) => room.groupId === requested) ?? rooms[0] ?? null;
